var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"moduldTit"},[_vm._v("考核评分表模板")])]),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('assessFormWrite',{attrs:{"isRole":[]}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }